"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMAND = void 0;
exports.COMMAND = {
    BLOCK_START: 'block-start',
    BLOCK_END: 'block-end',
    FRAGMENT_START: 'fragment-start',
    FRAGMENT_END: 'fragment-end',
    CHANGE_SELECTION: 'CHANGE_SELECTION',
    BACKSPACE: 'BACKSPACE',
    BACKSPACE_BLOCK_START: 'BACKSPACE_BLOCK_START',
    BACKSPACE_PREV_WORD: 'BACKSPACE_PREV_WORD',
    REMOVE_RANGE: 'REMOVE_RANGE',
    INSERT_TEXT: 'INSERT_TEXT',
    DELETE_FORWARD: 'DELETE_FORWARD',
    INSERT_CHARACTER: 'INSERT_CHARACTER',
    SPLIT_BLOCK: 'SPLIT_BLOCK',
    UNDO: 'UNDO',
    REDO: 'REDO',
    UPDATE_BLOCK_ENTITIES: 'UPDATE_BLOCK_ENTITIES'
};
//# sourceMappingURL=constants.js.map